import { render, staticRenderFns } from "./AttributesPainter.vue?vue&type=template&id=dd349394&scoped=true&"
import script from "./AttributesPainter.vue?vue&type=script&lang=js&"
export * from "./AttributesPainter.vue?vue&type=script&lang=js&"
import style0 from "./AttributesPainter.vue?vue&type=style&index=0&id=dd349394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd349394",
  null
  
)

export default component.exports